// extracted by mini-css-extract-plugin
export default {"toolTipWrapper":"styles_toolTipWrapper__Bu2+4","toolTipText":"styles_toolTipText__V+Fx0"};